import React, { FC, useState, useEffect } from "react";
import styled from "@emotion/styled";
import { TextField } from "@radix-ui/themes";
import { Button } from "@/components/button";

interface SearchFormProps {
  initialValue?: string;
  onSearch: (query: string) => void;
  onSearchMyAccount?: () => void;
  canSearchMyAccount?: boolean;
}

export const SessionsSearchForm: FC<SearchFormProps> = ({
  initialValue = "",
  onSearch,
  onSearchMyAccount,
  canSearchMyAccount = false,
}) => {
  const [inputValue, setInputValue] = useState<string>(initialValue);

  // Update input value when initialValue changes
  useEffect(() => {
    setInputValue(initialValue);
  }, [initialValue]);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onSearch(inputValue.trim());
  };

  return (
    <FormContainer onSubmit={handleSubmit}>
      <TextFieldContainer
        placeholder="Filter by Space Account ID..."
        value={inputValue}
        onChange={event => setInputValue(event.currentTarget.value)}
        maxLength={100}
        aria-label="Filter by Space Account ID"
        style={{ flex: 1 }}
      />
      <Button type="submit">Search</Button>
      {onSearchMyAccount && (
        <Button
          type="button"
          variant="soft"
          onClick={onSearchMyAccount}
          disabled={!canSearchMyAccount}
        >
          Fill in my account
        </Button>
      )}
    </FormContainer>
  );
};

const FormContainer = styled.form`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 2rem;
`;

const TextFieldContainer = styled(TextField.Root)`
  max-width: 360px;
`;
